import React from 'react';
import cx from 'classnames';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import PageComposer from 'Components/PageComposer/PageComposer';
import staticPagesStyles from 'Components/StaticPages/StaticPages.module.scss';
import Content from 'Storybook/local/Content/Content';
import { PAGE_SLUGS } from 'Utilities/consts';
import ROUTES from 'Utilities/routes';

import { SNOWPLOW_EVENTS } from '../../../services/analytics/analytics.const';
import { motorwayPayModulrEvents } from '../../../services/analytics/events/paymentEvents/motorwayPayModulrEvents';

import { SignUpToMotorwayPayBox } from './SignUpToMotorwayPayBox/SignUpToMotorwayPayBox';
import {
	type MotorwayPayModulrProps,
	MODULR_UK_SAFEGUARDING_EXPLANATION_LINK,
	MOTORWAY_PAY_FAQ_LINK,
} from './MotorwayPayModulr.helper';

import styles from './MotorwayPayModulr.module.scss';

export const MotorwayPayModulr: React.FC<MotorwayPayModulrProps> = ({ displayAs }) => (
	<PageComposer pageSlug={PAGE_SLUGS.MOTORWAY_PAY}>
		<Content className={cx(staticPagesStyles.StaticPages, staticPagesStyles.content, styles.localContainer)}>
			<div className={cx(staticPagesStyles.container)}>
				<div className={styles.texts}>
					<div>
						<h2>Motorway Pay & Modulr</h2>
						<p className={styles.date}>Last updated 17 July 2024</p>
					</div>

					<p>
						Motorway Online Ltd is a distributor of Modulr FS Limited, a company registered in England and Wales with
						company number 09897919, which is authorised and regulated by the Financial Conduct Authority as an
						Electronic Money Institution (Firm Reference Number: 900573) for the issuance of electronic money and
						payment services. Your account and related payment services are provided by Modulr FS Limited. Whilst
						Electronic Money products are not covered by the Financial Services Compensation Scheme (FSCS) your funds
						will be held in one or more segregated accounts and safeguarded in line with the Electronic Money
						Regulations 2011 - for more information please see{' '}
						<Hyperlink
							href={MODULR_UK_SAFEGUARDING_EXPLANATION_LINK}
							label="UK Safeguarding Explanation"
							onClick={() => {
								motorwayPayModulrEvents<{
									label: string;
								}>({
									customData: {
										label: 'UK Safeguarding Explanation',
									},
									name: 'Link clicked',
									schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
									version: SNOWPLOW_EVENTS.CLICK.VERSION,
								});
							}}
							target="_blank"
						/>
						{'.'}
					</p>
					<div className={styles.terms}>
						<h5>Terms & Conditions:</h5>
						<ul>
							<li>
								<Hyperlink
									href={ROUTES.PAYMENT_TERMS.href}
									label="Motorway Pay Terms & Conditions"
									onClick={() => {
										motorwayPayModulrEvents<{
											label: string;
										}>({
											customData: {
												label: 'Motorway Pay Terms & Conditions',
											},
											name: 'Link clicked',
											schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
											version: SNOWPLOW_EVENTS.CLICK.VERSION,
										});
									}}
									target="_blank"
								/>
							</li>
							<li>
								<Hyperlink
									href={ROUTES.MODULR_PAYMENT_TERMS.href}
									label="Modulr Terms & Conditions"
									onClick={() => {
										motorwayPayModulrEvents<{
											label: string;
										}>({
											customData: {
												label: 'Modulr Terms & Conditions',
											},
											name: 'Link clicked',
											schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
											version: SNOWPLOW_EVENTS.CLICK.VERSION,
										});
									}}
									target="_blank"
								/>
							</li>
						</ul>
					</div>

					{displayAs !== 'signedOut' && (
						<p className={styles.moreQuestion}>
							<strong>More questions?</strong> Check{' '}
							<Hyperlink
								href={MOTORWAY_PAY_FAQ_LINK}
								label="Motorway Pay FAQs"
								onClick={() => {
									motorwayPayModulrEvents<{
										label: string;
									}>({
										customData: {
											label: 'Motorway Pay FAQs',
										},
										name: 'Link clicked',
										schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
										version: SNOWPLOW_EVENTS.CLICK.VERSION,
									});
								}}
								target="_blank"
							/>
						</p>
					)}
				</div>
			</div>

			<div>{displayAs === 'signedInWithoutPayment' && <SignUpToMotorwayPayBox />}</div>
		</Content>
	</PageComposer>
);
